import { render, staticRenderFns } from "./user-report.vue?vue&type=template&id=72088f7c&"
import script from "./user-report.vue?vue&type=script&lang=js&"
export * from "./user-report.vue?vue&type=script&lang=js&"
import style0 from "./user-report.vue?vue&type=style&index=0&id=72088f7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports